export class Utilities {
    /**
    @name RemoveHyphens - removing hyphes from entered value.
    */
    static RemoveHyphens(input: string): string {
        if (input) {
            return input.replace(/-/g, ' ').trim();
        }
        return '';
    }

    /**
    @name GetTheme - Get Theme from URL
    */
    static GetLastPath(url: string): string {
        const clientPath = url && url !== '' ? url.split('/') : '';
        const clientTheme = clientPath[clientPath.length - 1];
        return clientTheme === '' ? 'lexus' : clientTheme;
    }

    /**
    @name GetPath - Get Theme from URL
    */
    static GetPath(url: string): string {
        const clientPath = url && url !== '' ? url.split('/') : '';
        const clientTheme = clientPath[clientPath.length - (clientPath.length - 1)];
        return clientTheme === '' ? 'lexus' : clientTheme;
    }

    /**
      @name getUniqueList - Remove duplicate items from array
      */
    static getUniqueList(array: Array<any>): Array<any> {
        return array.filter((el, i, a) => i === a.indexOf(el))
    }


    /**
      @name removeSpace - Remove Space between string
      */
    static removeSpace(str: string): string {
        str = str.toUpperCase().trim().replace(/\s/g, '');
        return str;
    }

    /**
     @name removeSpaceAndCamelCase - Remove Space between string
     */
    static removeSpaceAndCamelCase(str: string): string {
        if (str) {
            return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
                return index == 0 ? word.toUpperCase() : word.toLowerCase();
            }).replace(/\s+/g, '');
        }
    }

    static getQueryString(field: string, url: string) {
        const href = url ? url : window.location.href;
        const reg = new RegExp('[?&]' + field + '=([^&#]*)', 'i');
        const str = reg.exec(href);
        return str ? str[1] : null;
    }

    static isAdmin(url) {
        return url.includes('/admin');
    }

    static isToyotaExternal(url) {
        return url.includes('qa.toyotaaudioandconnectedservicessupport');
    }
  
    static isToyotaInternal(url) {
        return url.includes('qa.connectedtechnologiestoyota')
    }
  
    static isLexusExternal(url) {
        return url.includes('qa.lexusconnectedtechnologysupport')
    }
    
    static isLexusInternal(url) {
        return url.includes('qa.connectedtechnologieslexus')
    }

    static getEnvironment() {
        const hostname = window && window.location && window.location.hostname;
        switch(true) {
            // dev environments
            case (/^.*dev.connectedtechnologieslexus.com*/.test(hostname)) :
            case (/^.*dev.connectedtechnologiestoyota.com.*/.test(hostname)) :
            case (/^.*dev.toyotaaudioandconnectedservicessupport.com.*/.test(hostname)) :
            case (/^.*dev.lexusconnectedtechnologysupport.com.*/.test(hostname)) :
                return 'dev/'
            // uat environments
            case (/^.*localhost.*/.test(hostname)) :
            case (/^.*qa.connectedtechnologieslexus.com*/.test(hostname)) :
            case (/^.*qa.connectedtechnologiestoyota.com.*/.test(hostname)) :
            case (/^.*qa.toyotaaudioandconnectedservicessupport.com.*/.test(hostname)) :
            case (/^.*qa.lexusconnectedtechnologysupport.com.*/.test(hostname)) :
                return 'uat/';
            // prod environments
            case (/^.*connectedtechnologieslexus.com*/.test(hostname)) :
            case (/^.*connectedtechnologiestoyota.com.*/.test(hostname)) :
            case (/^.*toyotaaudioandconnectedservicessupport.com.*/.test(hostname)) :
            case (/^.*lexusconnectedtechnologysupport.com.*/.test(hostname)) :
                return 'prod/';
        }
    }

    static getBluetoothExternalPath() {
        switch(this.getEnvironment()) {
            case 'dev/':
            case 'uat/' :
                return 'https://tcrp.mmq.telematicsct.com/api/v3';
            case 'prod/':
                return 'https://tcrp.mmq.telematicsct.com/api/v3';
        }
    }

    static getTentantId() {
        switch(this.getEnvironment()) {
            case 'dev/':
            case 'uat/' :
                return 'tmnatest.onmicrosoft.com';
            case 'prod/':
                return '8c642d1d-d709-47b0-ab10-080af10798fb'
        }
    }

    static getAppId() {
        switch(this.getEnvironment()) {
            case 'dev/':
            case 'uat/' :
                return '73ed54a4-94cf-4ede-8c22-0be4b6e1f7da';
            case 'prod/':
                return 'b6892830-6788-4ee2-aeab-dd5705ecd725'
        } 
    }

    /**
    @name getSecondsUntilExpiry - Returns the number of milliseconds between now and the given date.
    */
    static getSecondsUntilExpiry(date: Date): number {
        const now = new Date();
        const differenceInMilliseconds: number = date.getTime() - now.getTime();
        const differenceInSeconds: number = Math.floor(differenceInMilliseconds / 1000);

        return differenceInSeconds;
    }
}
